type RuntimeTelemetryDebugStore = {
  counters: Record<string, number>;
  events: Array<{
    at: string;
    event: string;
    detail?: Record<string, unknown>;
  }>;
};

declare global {
  interface Window {
    __streamyRuntimeTelemetryDebug?: RuntimeTelemetryDebugStore;
  }
}

const isDevelopment = process.env.NODE_ENV === 'development';

export const estimatePayloadBytes = (payload: unknown) => {
  if (!isDevelopment) return undefined;
  try {
    return new Blob([JSON.stringify(payload)]).size;
  } catch {
    return undefined;
  }
};

export const recordRuntimeTelemetryDebug = (
  event: string,
  detail?: Record<string, unknown>
) => {
  if (!isDevelopment) return;
  const store = window.__streamyRuntimeTelemetryDebug || {
    counters: {},
    events: [],
  };
  store.counters[event] = (store.counters[event] || 0) + 1;
  const usedJsHeapSize = (performance as Performance & { memory?: { usedJSHeapSize?: number } }).memory?.usedJSHeapSize;
  store.events.push({
    at: new Date().toISOString(),
    event,
    detail: usedJsHeapSize ? { ...detail, usedJsHeapSize } : detail,
  });
  if (store.events.length > 200) store.events.splice(0, store.events.length - 200);
  window.__streamyRuntimeTelemetryDebug = store;
};

export const adjustRuntimeTelemetryDebugGauge = (gauge: string, delta: number) => {
  if (!isDevelopment) return;
  const store = window.__streamyRuntimeTelemetryDebug || {
    counters: {},
    events: [],
  };
  store.counters[gauge] = Math.max(0, (store.counters[gauge] || 0) + delta);
  window.__streamyRuntimeTelemetryDebug = store;
  recordRuntimeTelemetryDebug(`${gauge}:changed`, { value: store.counters[gauge] });
};
